module.exports = __webpack_public_path__ + "37324991710443a70312176f9555dcc3.pdf";